import styled from "styled-components"
import {
  REVIEW_REASON_COPY,
  REVIEW_REASON_FALLBACK_COPY,
} from "~constants/proofOfOwnership"

interface AINotProcessedBoxProps {
  reviewReason: string
}

const AINotProcessedBox = ({ reviewReason }: AINotProcessedBoxProps) => {
  const copy = REVIEW_REASON_COPY[reviewReason] || REVIEW_REASON_FALLBACK_COPY

  return (
    <Container>
      <Inner>
        <IconCircle>!</IconCircle>
        <ReasonText>{copy}</ReasonText>
      </Inner>
    </Container>
  )
}

// The box (background) spans the full row; Inner keeps the content left-aligned,
// consistent with the validate/reject suggestion banners.
const Container = styled.div`
  padding: 8px 14px;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
`

// No width cap here (unlike the validate/reject banners): this notice has no
// action button, just a one-line message — let it use the full row so the text
// doesn't wrap awkwardly.
const Inner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const IconCircle = styled.div`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f59e0b;
  color: white;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
`

const ReasonText = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 400;
  color: #92400e;
`

export default AINotProcessedBox
